import { createSelector } from '@reduxjs/toolkit'
import type { RootState } from '@/redux/store'

const selectSlice = (state: RootState) => state.reducer.toasts

/** All toasts currently in the queue. */
export const selectToastQueue = (state: RootState) => selectSlice(state).queue

/** Toasts that are actively displayed (first `pageSize` items), sticky toasts pinned to top. */
export const selectVisibleToasts = createSelector(
  selectSlice,
  ({ queue, pageSize }) => {
    const sticky = queue.filter((t) => t.dismissMode !== 'auto')
    const auto = queue.filter((t) => t.dismissMode === 'auto')
    return [...sticky, ...auto].slice(0, pageSize)
  },
)

/** Number of toasts waiting behind the current page. */
export const selectQueuedCount = (state: RootState) => {
  const { queue, pageSize } = selectSlice(state)
  return Math.max(0, queue.length - pageSize)
}
